import { render, staticRenderFns } from "./aktiveLogs.vue?vue&type=template&id=80a47098&scoped=true&"
import script from "./aktiveLogs.vue?vue&type=script&lang=js&"
export * from "./aktiveLogs.vue?vue&type=script&lang=js&"
import style0 from "./aktiveLogs.vue?vue&type=style&index=0&id=80a47098&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a47098",
  null
  
)

export default component.exports